export const isDirectClickoutRetailerExcluded = (retailerId: number): boolean => {
  const excludedRetailers = process.env.NEXT_PUBLIC_RETAILERS_EXCLUDE_DIRECT_CLICKOUT;

  if (!excludedRetailers) {
    return false;
  }
  const retailersArray = excludedRetailers.split(',').filter(Boolean).map(Number);
  return retailersArray.includes(retailerId);
};
